<template>
  <footer class="footer">
    <div class="f-main">
      <div class="f-left">
        <div class="f-item">
          <h3>热门服务</h3>
          <div class="f-link">
            <a href="/index/inquire" target="_blank">IDM一站式下单</a>
            <a href="/index/PCB" target="_blank">PCB下单</a>
            <a href="/index/PCBA" target="_blank">PCBA下单</a>
            <a href="/index/BOM" target="_blank">BOM下单</a>

            <!-- <a :href="config.domain + '/solution/projectNew'" target="_blank">IDH方案设计</a> -->
            <!-- <a :href="config.orderDomain + '/cad'" target="_blank">高速PCB设计</a> -->
            <!-- <a href="/index/PCBA" target="_blank">PCBA装联</a> -->
            <!-- <a :href="config.domain + '/solution/server'" target="_blank">电子工程服务</a> -->
            <!-- <a href="/goods/index" target="_blank">BOM配齐</a> -->
          </div>
        </div>
        <div class="f-item">
          <h3>服务支持</h3>
          <div class="f-link">
            <a href="/cad" target="_blank">设计能力</a>
            <a :href="config.domain + '/technology/pcbCraft'" target="_blank">PCB生产制造</a>
            <a :href="config.domain + '/technology/pcbACraft'" target="_blank">PCBA装联</a>
            <a :href="config.domain + '/technology/bomCraft'" target="_blank">BOM配齐</a>
          </div>
        </div>
        <div class="f-item">
          <h3>关于我们</h3>
          <div class="f-link">
            <a :href="config.domain + '/aboutUs'">公司介绍</a>
            <a :href="config.domain + '/newsColumn?categoryId=128'">新闻动态</a>
            <a :href="config.domain + '/newsColumn?categoryId=129'">通知公告</a>
            <a rel="nofollow" :href="config.domain + '/supplier'" target="_blank">生态合作</a>
            <!-- <a rel="nofollow" href="http://dywcollege.com/index.html" target="_blank">硬见理工教研院</a> -->
            <!-- <a href="javascript:void(0);" @click="openProtocol">服务协议</a>
            <a href="javascript:void(0);" rel="nofollow">加入我们</a>
            <a href="javascript:void(0);" rel="nofollow">我要反馈</a> -->
          </div>
        </div>
        <div class="f-item">
          <h3>帮助中心</h3>
          <div class="f-link">
            <a :href="config.domain + '/helpCenter/detail?detailId=16885'">下单流程</a>
            <a :href="config.domain + 'helpCenter/detail?detailId=16882'">付款流程</a>
            <a :href="config.domain + '/helpCenter/detail?detailId=16881'">开票流程 </a>
            <a :href="config.domain + '/helpCenter/list?categoryId=127'">常见问题</a>
          </div>
        </div>
        <!-- <div class="f-item">
          <h3>工艺能力</h3>
          <div class="f-link">
            <a :href="config.domain + '/technology/pcbACraft'">PCBA装联</a>
            <a :href="config.domain + '/technology/pcbCraftSecondary'" target="_blank">刚挠结合板</a>
            <a :href="config.domain + '/technology/cadCraft'">PCB设计</a>
            <a :href="config.domain + '/technology/pcbCraftSecondary'" target="_blank">高频板</a>
            <a :href="config.domain + '/technology/pcbCraftSecondary'" target="_blank">HDI板</a>
            <a :href="config.domain + '/technology/pcbCraftSecondary'" target="_blank">金属基板</a>
            <a :href="config.domain + '/technology/pcbCraftSecondary'" target="_blank">高多层板</a>
            <a :href="config.domain + '/technology/pcbCraftSecondary'" target="_blank">厚铜电源板</a>
          </div>
        </div> -->
        <!-- /idm/view/list.html?id=6186&pid=86 -->
        <!-- <div class="f-item">
          <h3>帮助中心</h3>
          <div class="f-link">
            <a :href="config.domain + '/helpCenter/detail?detailId=11954'" target="_blank">下单流程</a>
            <a :href="config.domain + '/helpCenter/detail?detailId=11946'" target="_blank">付款流程</a>
            <a
              :href="config.domain + '/idm/view/list.html?id=6200&pid=87'"
              target="_blank"
              >开票流程</a
            >
            <a :href="config.domain + '/helpCenter/list?categoryId=132'" target="_blank">常见问题</a>

            <a :href="config.domain + '/helpCenter/detail?detailId=11951'" target="_blank">开票注意事项</a>
          </div>
        </div> -->
        <!-- <div class="f-item">
          <h3>关于我们</h3>
          <div class="f-link">
            <a :href="config.domain + '/idm/view/aboutUs.html'">关于我们</a>
            <a href="javascript:void(0);" @click="openProtocol">服务协议</a>
            <a href="javascript:void(0)" target="_blank">加入我们</a>
            <a href="javascript:void(0)" target="_blank">我要反馈</a>
          </div>
        </div>
        <div class="f-item">
          <h3>新闻动态</h3>
          <div class="f-link">
            <a :href="config.domain + '/idm/view/newsColumn.html?type=1'">造物动态</a>
            <a :href="config.domain + '/idm/view/newsColumn.html?type=2'">行业动态</a>
            <a :href="config.domain + '/idm/view/newsColumn.html?type=3'">技术论坛</a>
          </div>
        </div>
        <div v-if="false" class="f-item">
          <h3>友情链接</h3>
          <div class="f-link">
            <a href="https://www.kingbrother.com/" target="_blank">金百泽科技</a>
            <a href="http://www.idfm.cn/" target="_blank">云创造物</a>
            <a href="http://dywcollege.com/" target="_blank">硬见理工教研院</a>
            <a :href="config.domain" target="_blank">InZ应龙</a>
            <a href="http://dywork.cn/" target="_blank">云创工场</a>
            <a href="http://www.kingconn.com/" target="_blank">佰富物联</a>
          </div>
        </div> -->
      </div>
      <div class="f-right">
        <p class="name">
          <img src="./bottom-logo2.svg" alt="InZ应龙" style="width: 158px; height: 32px; border-right: 1px solid #646a6f" />
          <img src="./bottom-logo1.svg" alt="InZ应龙" style="width: 158px; height: 26px" />
        </p>
        <div style="padding-left: 28px">
          <h3 style="margin: 24px 0">电话：400-688-2850</h3>
          <div class="mail close-bom">商务合作：service@inzaowu.com</div>
          <div class="mail">供应商合作：supplier@inzaowu.com</div>
        </div>

        <div class="cont">
          <img src="./focusCode@2x1.jpg" alt="pcb打样_InZ应龙" />
          <img src="./focusCode@2x2.jpg" alt="pcb打样_InZ应龙" />
        </div>
      </div>
    </div>
    <div class="copyright-main">
      <div class="copyright">
        <a href="https://beian.miit.gov.cn" target="_blank"> 深圳市造物数字工业科技有限公司 @ All Rights Reserved 粤ICP备2023137608号</a>
      </div>
      <!-- <div class="copyrightNew">
        <a target="_blank" href="/static/img/kbidm.pdf"
          >增值电信业务经营许可证粤B2-20220318</a
        >
      </div> -->
    </div>
  </footer>
</template>

<script>
import * as util from 'assets/js/util'

export default {
  props: {
    bgColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activityShow: false,
      config: util.config
    }
  },
  created() {},
  methods: {
    openProtocol() {
      var html =
        '<p class="preface">感谢您使用InZ应龙订单系统，本系统为您提供关于集成IDM（PCB、PCBA、BOM）、现货、等定制加工服务，在使用前，请您仔细阅读以下内容，只有在您接受并遵守以下条款后再进行下一步操作。</p>' +
        '          <div class="cont">' +
        '            <p>一、下单</p>' +
        '            <p>1、顾客请如实填写加工参数，测算价格只针对加工参数有效，具体订单价格以加工文件与订单审核结果为准。</p>' +
        '            <p>（2、订单审核过程需要专业人员人工干预，所以顾客下单以后需要等待后台订单审核，审核等待时间预计不会超过30分钟。</p>' +
        '            <p>二、支付</p>' +
        '            <p>1、系统支持预充值、支付宝或银联网银支付，为了您的下单顺畅和高效，强烈建议你采用预充值或支付宝方式进行支付。</p>' +
        '            <p>2、顾客请在订单完成审核状态后72小时内完成付款操作，逾期系统将自动取消该订单。</p>' +
        '            <p>3、请勿重复提交订单。当您进行支付后，请查询订单支付状态，系统如没有返回异常提醒，请勿急于重复提交订单，请您在服务时间拨打400-688-2850咨询，以免造成您不必要的损失。</p>' +
        '            <p>三、状态查询</p>' +
        '            <p>1、订单下单后支持对订单明细信息进行查询，包括加工文件、加工参数、订单计价信息等</p>' +
        '            <p>2、订单完成付款之后将支持针对订单在制情况的WIP查询，方便顾客快捷清晰了解产品的整体加工状态</p>' +
        '            <p>3、订单发货状态之后将支持发货物流的快速查询，方便顾客快捷直接了解货物物流流转状态</p>' +
        '            <p>四、售后服务</p>' +
        '            <p>1、每个订单我们在加工过程都会按照订单难度进行一定量的预投管理，但由于定制加工服务受（品质、环境、材料等）客观因素影响较大，存在报废而造成订单缺数情况，需要顾客谅解。在订单出现缺数情况下系统会发出缺数处理确认的提醒（包括短信提醒），请您尽快进行处理方案确认，以免造成订单交期影响。超过24小时未进行确认的，我们将默认按缺数退款方式处理。</p>' +
        '            <p>2、针对BOM器件，因实际收货数量不对、型号不符、产品质量问题需要退货的客户，在收货后的两周内可提出退货申请，逾期恕不受理。默认情况下，平台器件产品质保期为确认收货日起1年（特殊备注产品除外）。</p>' +
        '            <p>3、退货产品，请务必保留完整的原包装(包括外包装、内填充物)及确保货物标签完好，货物标签是我司与供应商协调退货的唯一凭据，如有遗失，将无法受理。如因产品质量问题申请退货，客户需提供详细的性能检测报告作为我司与供应商的协商依据。如有必要，还需提供双方认可的第三方检测报告。</p>' +
        '            <p>4、顾客对收到的产品存在投诉或不满，请通过系统客诉管理发起客诉，我们的工作人员将会尽快与您取得联系，如情况紧急请直接电话联系客服。客诉过程双方应本着共赢互利原则进行沟通处理，我们将尽可能地为顾客提供满意的服务。如涉及赔款，赔款金额不超过本异常批次的合同原值。</p>' +
        '            <p>5、顾客在收到货物后请及时在系统中进行收货确认处理，从供方发货时间开始计算，超过10天没有进行收货确认，系统将默认完成收货确认处理。</p>' +
        '            <p>6、已开具发票的订单在退货申请通过后，需退回发票。</p>' +
        '            <p>五、发票管理</p>' +
        '            <p>1、下单时允许顾客自行选择是否有发票需要。</p>' +
        '            <p>2、增值税发票每月首次申请不限金额，第二次申请需要满3000元以上才能进行开票申请。</p>' +
        '            <p>3、普通发票默认将随货物一并发出。</p>' +
        '            <p>六、双方权利义务</p>' +
        '            <p style="text-indent: 2em;">当顾客的下单产品涉及方案设计定制时，在产品设计生产过程中，双方的沟通往来，需遵循以下条款：</p>' +
        '            <p>1、顾客权利义务</p>' +
        '            <p>（1）顾客下单后有权对产品的设计提出建议和思路，以使产品的设计作品更符合要求。如顾客提出的建议，经与InZ应龙确认，确实构成一个新的设计要求，则需就设计费的调整、设计时限的延长、设计成果的交付时间等另行签订补充协议；</p>' +
        '            <p>（2）顾客有权利用产品按照协议约定提供的研究开发成果，进行后续改进。由此产生的具有实质性或创造性技术进步特征的新的技术成果及其权属，由顾客享有。</p>' +
        '            <p>（3）顾客需及时向InZ应龙提供技术文件等基础资料以免延误工期；</p>' +
        '            <p>（4）在设计过程中如顾客增减变更内容应及时与InZ应龙协商，并签订变更协议书；</p>' +
        '            <p>（5）顾客有义务按照协议约定支付相关费用。顾客在未付设计费用之前，对该设计作品不享有任何权利；且顾客将协议每期设计款项支付完毕后，才拥有所支付设计作品的所有权、著作权和修改权。</p>' +
        '            <p>2、InZ应龙权利义务</p>' +
        '            <p>（1）严格执行本协议条款，按顾客所提供的文件、资料和具体要求进行设计制作，未经顾客书面许可，InZ应龙无权擅自变更设计方案；</p>' +
        '            <p>（2）在后期样机制作过程中，如因InZ应龙的设计而导致的设计工期延误及造成的相关损失均由InZ应龙承担。</p>' +
        '            <p>（3）InZ应龙对顾客提供的全部技术文件、基础资料负有保密义务,不得向第三方泄露。</p>' +
        '            <p>（4）顾客选定的设计方案，未经顾客书面许可，InZ应龙不得为第三方重复设计使用；</p>' +
        '            <p>（5）顾客指定InZ应龙为本产品的唯一合格合作方，InZ应龙应保证其量产产品符合国家相关标准，同时满足双方约定的质量要求。</p>' +
        '            <p>（6）InZ应龙有权要求顾客按照协议约定支付相应款项。在未收到顾客支付的分期款项，有权利拒绝开展下一阶段工作和交付相应阶段设计成果，因此导致的设计工期延误及造成的相关损失均由顾客承担。</p>' +
        '            <p>七、知识产权及保密</p>' +
        '            <p>1、知识产权</p>' +
        '            <p>（1）顾客选定并已支付的设计方案和其他设计成果，包括但不限于外观设计专利申请权、专利权、设计图版权等全部知识产权、所有权属甲方所有，InZ应龙对该设计方案和设计成果享有署名权。</p>' +
        '            <p>（2）顾客未选定的设计方案，设计方案及设计内容版权归InZ应龙所有，未经InZ应龙同意顾客无权使用。否则，InZ应龙有权追究甲方的侵权责任。</p>' +
        '            <p>（3）InZ应龙保证对本协议下的设计工作自行创作设计，如存在故意侵犯他人知识产权或违反InZ应龙与第三方的保密义务，InZ应龙应自行承担侵权或违约责任。</p>' +
        '            <p>（4）顾客选定设计方案产品上市后或者其专利申请公开后，InZ应龙可以将该设计方案成果用于展出、展示、参加评比等相应的活动。</p>' +
        '            <p>2、保密义务</p>' +
        '            <p>（1）顾客与InZ应龙双方有义务尽可能提供对方基于本项目进行所需的相关资料，且仅为履行本合同使用。</p>' +
        '            <p>（2）InZ应龙对本协议的所有相关内容及其在签订、履行过程中所获知的所有顾客尚未公开的信息进行保密（包括但不限于本合同书内容、产品图样、原形、制程式、概念、发现、模具、创作元件、操作手册、产品规格、专门技术、销售资料、技术资料、顾客资料、产品报价及其他非经提供无以知悉的相关经营及技术资料。）。</p>' +
        '            <p>（3）InZ应龙按约定提供给顾客的设计成果、设计方案进行保密。</p>' +
        '            <p>八、注意事项</p>' +
        '            <p>1、系统下单时请务必保管好您个人帐号、密码、回单等资料，建议勿在网吧等公共场所使用本下单系统。</p>' +
        '            <p>2、顾客应按照系统提示认真进行下单操作，因顾客个人原因造成的损失由顾客自行承担。</p>' +
        '            <p>3、交易过程中如发现已被扣款，但系统未显示成功支付，请及时联系客服人员进行核实处理。</p>' +
        '            <p>九、免责声明</p>' +
        '            <p>1、在不抵触适用法律的最大范围内，InZ应龙既不保证此网站不受干扰及没有错误，亦不保证此网站或提供此网站的服务器没有病毒、感染或其它有害物质。InZ应龙不会就使用此网站、使用链接此网站的任何网站或使用经此等网站提供的任何产品或服务而产生的任何特定结果作出任何担保或保证。</p>' +
        '            <p>2、InZ应龙有权在必要时修改本服务条款以及各单项服务的相关条款。顾客在使用时，应当及时查阅了解相关内容并自觉遵守。</p>' +
        '            <p>3、InZ应龙订单系统保留随时修改或中断服务而不需通知顾客的权利。</p>' +
        '            <p>4、本服务条款的最终解释权归InZ应龙所有。</p>' +
        '          </div>'
      this.$alert(html, '服务协议', {
        dangerouslyUseHTMLString: true,
        customClass: 'protocol-cont',
        closeOnClickModal: true,
        closeOnPressEscape: true
      })
    },
    closeActivity() {
      this.activityShow = false
    }
  },
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '~assets/scss/compile';
@import './footer';
</style>



// WEBPACK FOOTER //
// src/components/common/footer/footer.vue